import { render, staticRenderFns } from "./NotesSection.vue?vue&type=template&id=d8fc6640&"
import script from "./NotesSection.vue?vue&type=script&lang=js&"
export * from "./NotesSection.vue?vue&type=script&lang=js&"
import style0 from "./NotesSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports